export default () => ({
    why: {},
    slider:{},
    grid:{},
    hint:{},
    topicNews:{},
    loading: false,
    error: false,
    contactDetails:{},
    socialMedia:{},
    mainMenu:{},
    lightweightBlockMenu:[],
    materialHeaderMenu:[],
    glassHeaderMenu:[]
});
